(function () {
  'use strict';

  angular.module('app').service('ProductCategoryModalService', ProductCategoryModalService);

  ProductCategoryModalService.$inject = ['ModalService'];

  function ProductCategoryModalService(ModalService) {
    let service = {
      openProductCategories: openProductCategories,
    };

    return service;

    ////////////////

    function openProductCategories(getItemsCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/product-categories/modals/product-category-list-modal.html',
        controller: ProductCategoryListModalCtrl,
        controllerAs: 'vm',
      }).then(function (modal) {
        modal.element.modal();

        modal.element.on('hidden.bs.modal', function () {
          getItemsCallback();
        });
      });
    }

    function ProductCategoryListModalCtrl(
      ProductCategoryService,
      LanguageService,
      AbilityService,
      UtilService
    ) {
      var vm = this;

      vm.UtilService = new UtilService(vm);

      vm.permissions = {
        canList: AbilityService.can('index_productcategory_accountadmin'),
        canCreate: AbilityService.can('create_productcategory_accountadmin'),
      };

      vm.items = {};
      vm.meta = {};

      vm.addItem = addItem;
      vm.onSavedItem = onSavedItem;
      vm.cancel = cancel;
      vm.onCanceledItem = onCanceledItem;
      vm.onShowItem = onShowItem;
      // vm.onDeletedItem  = onDeletedItem;

      // Initializers
      // getItems();
      getAdditionalLanguages();

      function getItems(selectedItem) {
        vm.modalTitle = 'PRODUCT_CATEGORIES';

        if (!vm.permissions.canList) {
          return;
        }

        vm.filterCriteria = ProductCategoryService.getFilterCriteria();
        vm.filterCriteria.lang = vm.defaultLanguage;

        vm.loadingItems = true;
        ProductCategoryService.getProductCategories(vm.filterCriteria).then(function (data) {
          vm.items = data.items;
          vm.meta = data.meta;

          if (selectedItem) {
            vm.UtilService.itemListChanged(selectedItem.id);
          }

          vm.loadingItems = false;
        });
      }

      function getAdditionalLanguages() {
        LanguageService.getLanguages({ skip_check_role: true }).then(function (data) {
          let languages = data.items;

          vm.defaultLanguage = languages.filter((language) => language.is_default)[0].lang;
          vm.additionalLanguages = languages.filter((language) => !language.is_default);

          getItems('');
        });
      }

      function getItem(item) {
        vm.item = null;

        vm.loadingItem = true;
        ProductCategoryService.getProductCategory(item.id, vm.defaultLanguage).then(function (
          data
        ) {
          vm.item = data;

          vm.loadingItem = false;
        });
      }

      function addItem() {
        vm.createMode = true;
        vm.item = {};
        vm.modalTitle = 'NEW_PRODUCT_CATEGORY';
      }

      function onSavedItem(item) {
        //vm.UtilService._clearFlashMessage();
        //getItem(item);
        cancel(item);
      }

      function cancel(item) {
        vm.createMode = false;
        vm.editMode = false;

        getItems(item);
      }

      function onCanceledItem() {
        cancel('');
      }

      function onShowItem(item, mode) {
        vm.editMode = true;
        vm.modalTitle = 'PRODUCT_CATEGORY_DETAILS';

        vm.mode = mode;

        getItem(item);
      }

      // function onDeletedItem() {
      //     cancel();
      // }
    }
  }
})();
